import { render, staticRenderFns } from "./UserParamsForm.vue?vue&type=template&id=4635aa05&scoped=true"
import script from "./UserParamsForm.vue?vue&type=script&lang=js"
export * from "./UserParamsForm.vue?vue&type=script&lang=js"
import style0 from "./UserParamsForm.vue?vue&type=style&index=0&id=4635aa05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635aa05",
  null
  
)

export default component.exports